import React from 'react';
import moment from 'moment';
import { AccentH5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';
import Icon from './Icon';

export default function Summary({ deliveryDate = {}, slot = {} }) {
  const { start, description } = slot;
  const isImmediateDelivery = start === null;

  return (
    <>
      <Icon />
      <AccentH5 tag="h2" className={uppercase}>
        {isImmediateDelivery
          ? description
          : scheduledPhrase({
              description: slot.description,
              date: deliveryDate.date
            })}
      </AccentH5>
    </>
  );
}

function scheduledPhrase({ date, description }) {
  const dateIsToday = moment().format('MM/DD/YYYY') === date;
  const phrasePrefix = dateIsToday
    ? 'Today,'
    : moment(new Date(date)).format('ddd, MMM D,');

  return `${phrasePrefix} ${description}`;
}
